import React from 'react';
import { HiStar } from 'react-icons/hi';
import './Testimonials.css';

interface Testimonial {
  name: string;
  role: string;
  company: string;
  initials: string;
  text: string;
  rating: number;
  gradient: string;
}

const testimonials: Testimonial[] = [
  {
    name: 'Carlos Mendes',
    role: 'CTO',
    company: '',
    initials: 'CM',
    text: 'Opsight transformou como nossa equipe visualiza métricas. Agora temos clareza total sobre nosso ciclo de desenvolvimento e conseguimos identificar gargalos rapidamente.',
    rating: 5,
    gradient: 'linear-gradient(135deg, var(--chart-1) 0%, var(--chart-2) 100%)'
  },
  {
    name: 'Ana Paula',
    role: 'Engineering Manager',
    company: '',
    initials: 'AP',
    text: 'A integração foi super simples e os dashboards são incríveis. Nossa equipe finalmente tem visibilidade real sobre performance e pode tomar decisões baseadas em dados.',
    rating: 5,
    gradient: 'linear-gradient(135deg, var(--chart-2) 0%, var(--chart-3) 100%)'
  },
  {
    name: 'Roberto Silva',
    role: 'VP Engineering',
    company: '',
    initials: 'RS',
    text: 'As métricas de deploy e workflow nos ajudaram a reduzir significativamente nosso tempo de ciclo. A ferramenta é essencial para qualquer time de engenharia sério.',
    rating: 5,
    gradient: 'linear-gradient(135deg, var(--chart-3) 0%, var(--chart-4) 100%)'
  }
];

export const Testimonials: React.FC = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h2 className="testimonials-title">O que nossos clientes dizem</h2>
          <p className="testimonials-subtitle">
            Times de engenharia confiam no Opsight para melhorar continuamente
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {Array.from({ length: testimonial.rating }).map((_, i) => {
                  const StarIcon = HiStar as any;
                  return <StarIcon key={i} className="star-icon" />;
                })}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div 
                  className="testimonial-avatar"
                  style={{ background: testimonial.gradient }}
                >
                  {testimonial.initials}
                </div>
                <div className="testimonial-info">
                  <div className="testimonial-name">{testimonial.name}</div>
                  <div className="testimonial-role">
                    {testimonial.role} • {testimonial.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

